// extracted by mini-css-extract-plugin
module.exports =  {"card":"PendingGroupCard-Yy9E__card","header":"PendingGroupCard-yYQ5__header","title":"PendingGroupCard-GkPr__title","message":"PendingGroupCard-cqXU__message"};